import { Box, Button, SxProps, Theme, Typography, alpha } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router';
import MultipleHeartsImage from '../../assets/images/multiple_hearts.png';
import { RoutePaths } from '../../routes/AppRoutes';

export interface DiscoveryRedirectCardProps {
  parentBoxSx?: SxProps<Theme>;
}

export default function DiscoveryRedirectCard({ parentBoxSx }: DiscoveryRedirectCardProps): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        bgcolor: 'favoriteContainer.main',
        borderRadius: 4,
        p: 2,
        boxShadow: `-4px -16px 20px 0 ${alpha('#FF0022', 0.1)} inset, 0 4px 15px 0 ${alpha('#9B0115', 0.04)}`,
        boxSizing: 'border-box',
        ...parentBoxSx,
      }}
    >
      <Box>
        <Box
          component="img"
          src={MultipleHeartsImage}
          alt=""
          sx={{
            width: '100%',
            borderRadius: 3,
            height: {
              xs: 126,
              lg: 144,
            },
            display: 'block',
            aspectRatio: '16/9',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Typography variant="titleLarge" sx={{ color: 'onFavoriteContainer.main' }}>
        {t('products:discovery_redirect_title')}
      </Typography>
      <Typography variant="bodyMedium" sx={{ color: 'onFavoriteContainer.main' }}>
        {t('products:discovery_redirect_description')}
      </Typography>
      <Button
        variant="marketing"
        component={Link}
        to={generatePath(RoutePaths.DISCOVERY_SUPPLIERS)}
        fullWidth
        sx={{ mt: 1 }}
      >
        {t('products:discovery_redirect_cta')}
      </Button>
    </Box>
  );
}
